<mat-radio-group [attr.aria-labelledby]="question().id" class="single-choice-group" [formControl]="questionGrp().get('value') | toFormControl" color="primary">
  @for (option of visibleOptions$(); track option.id) {
    @if (question().useOtherInd && question().useOtherPosition === $index) {
      <ng-container *ngTemplateOutlet="other"></ng-container>
      <ng-container *ngTemplateOutlet="otherText"></ng-container>
    }

    @if (!!option.stimulus?.mediaId) {
      <empathy-option-media [media]="option.stimulus" [altText]="option.text" (clicked)="onCheck(option)">
        <ng-container [ngTemplateOutlet]="radiobutton"></ng-container>
      </empathy-option-media>
    } @else {
      <div class="single-choice-group__radiobutton" [class.use-media]="useMedia$()" (click)="onCheck(option)">
        <ng-container [ngTemplateOutlet]="radiobutton"></ng-container>
      </div>
    }

    <ng-template #radiobutton>
      <mat-radio-button color="accent" [disableRipple]="true" [value]="option.value">
        <div class="survey-viewer__html-content fs__md" [innerHTML]="option.text"></div>
      </mat-radio-button>
    </ng-template>

    @if (question().useOtherInd && question().useOtherPosition >= visibleOptions$().length && $last) {
      <ng-container *ngTemplateOutlet="other"></ng-container>
      <ng-container *ngTemplateOutlet="otherText"></ng-container>
    }
  }

  <ng-template #other>
    <div class="single-choice-group__radiobutton" [class.use-media]="useMedia$()" (click)="onCheck({ value: 'OTHER' })">
      <mat-radio-button color="accent" [disableRipple]="true" value="OTHER">
        <span class="survey-viewer__html-content fs__md"> {{ 'system.other' | translate }} </span>
      </mat-radio-button>
    </div>
  </ng-template>
</mat-radio-group>

<ng-template #otherText>
  @if (questionGrp().get('value').value === 'OTHER') {
    <div class="question-form__input">
      <span class="label survey-viewer__html-content fs__md fw__400" [innerHTML]="question().otherLabel"></span>
      <mat-form-field appearance="outline" class="eiq-survey-textarea">
        <textarea
          matInput
          surveyAutoFocus
          [formControl]="questionGrp().get('otherText') | toFormControl"
          [required]="questionGrp().get('value').value === 'OTHER'"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
  }
</ng-template>
